<div class="container-fluid login-bg">
  <div class="container">
    <form [formGroup]="loginForm" class="admin-forms login">
      <div class="input-fileds-container">
        <div class="group mb-2">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>UserName</mat-label>
            <input matInput formControlName="username" required />
            <mat-error>Please enter valid user name</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="input-fileds-container">
        <div class="group">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Password</mat-label>
            <input
              type="password"
              matInput
              formControlName="password"
              required
            />
            <mat-error>Please enter valid password</mat-error>
          </mat-form-field>
        </div>
      </div>
      <button (click)="login()" [class.spinner]="loading" [disabled]="loading">
        Login
      </button>
    </form>
  </div>
</div>
